import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';

export const ACTIVE_ASSET_DELETIONS_QUERY_KEY = 'assets.activeAssetDeletions';
export const ACTIVE_DELETIONS_POLL_MS = 3000;
export const IDLE_DELETIONS_POLL_MS = 60_000;

export const useActiveAssetDeletions = () => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useQuery({
    queryKey: [ACTIVE_ASSET_DELETIONS_QUERY_KEY, { tenantId }],
    queryFn: async () => {
      const response = await api.assets.listActiveAssetDeletions(tenantId);
      return response.data.deletions;
    },
    enabled: !!tenantId,
    refetchInterval: query => ((query.state.data?.length ?? 0) > 0 ? ACTIVE_DELETIONS_POLL_MS : IDLE_DELETIONS_POLL_MS),
  });
};
